import React from 'react';
import { ResumeData } from '../../../../../types/resume';
import SummaryHeader from './SummaryHeader';
import SummaryEditor from './SummaryEditor';
import SummaryTips from './SummaryTips';

interface Props {
  data: ResumeData;
  onUpdate: (data: Partial<ResumeData>) => void;
}

export default function SummaryForm({ data, onUpdate }: Props) {
  const handleSummaryChange = (summary: string) => {
    onUpdate({
      personalInfo: {
        ...data.personalInfo,
        summary
      }
    });
  };

  return (
    <div className="space-y-8">
      <SummaryHeader />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <SummaryEditor
            value={data.personalInfo?.summary || ''}
            onChange={handleSummaryChange}
          />
        </div>
        
        <div className="lg:col-span-1">
          <SummaryTips />
        </div>
      </div>
    </div>
  );
}